import classNames from 'classnames';

import { RenderHTML } from '../render-html/render-html';
import { CancelIcon, InformationIcon } from '../svgs';
import { type AlertVariant } from './alertVariant';

import styles from './alert.module.scss';

export type AlertProps = {
  className?: string;
  closeButtonLabel?: string;
  displayIcon?: boolean;
  heading?: string;
  id?: string;
  message?: string;
  messageHtml?: string;
  onClose?: () => void;
  variant?: AlertVariant;
};

export const Alert = ({
  className,
  closeButtonLabel,
  displayIcon = true,
  heading,
  id = '',
  message,
  messageHtml,
  onClose,
  variant,
}: AlertProps) => {
  return (
    <div
      className={classNames(styles.alert, className, {
        [styles[`alert__variant--${variant}`]]: variant,
        [styles[`alert__variant`]]: variant,
      })}
    >
      {displayIcon && (
        <div>
          <InformationIcon className={styles['alert__icon']} />
        </div>
      )}
      <div className={styles['alert__content']}>
        {heading && <strong className={styles['alert__heading']}>{heading}</strong>}
        {messageHtml ? (
          <RenderHTML
            aria-live="polite"
            as="p"
            className={styles['alert__message']}
            html={messageHtml}
            id={id}
            role="alert"
          />
        ) : (
          <p aria-live="polite" className={styles['alert__message']} id={id} role="alert">
            {message}
          </p>
        )}
      </div>
      {onClose && (
        <div className={styles['alert__close-button-wrapper']}>
          <button
            aria-label={closeButtonLabel || 'close'}
            className={styles['alert__close-button']}
            onClick={onClose}
          >
            <CancelIcon className={styles['alert__button-icon']} />
          </button>
        </div>
      )}
    </div>
  );
};
